import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastVariant = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  message: string
  variant: ToastVariant
  duration: number
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])

  function add(message: string, variant: ToastVariant = 'info', duration = 4_000): void {
    const normalizedMessage = message.trim()
    if (!normalizedMessage) return
    const duplicate = toasts.value.find((toast) => toast.variant === variant && toast.message === normalizedMessage)
    if (duplicate) return
    const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    toasts.value.push({ id, message: normalizedMessage, variant, duration })
    setTimeout(() => remove(id), duration)
  }

  function remove(id: string): void {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  const success = (msg: string) => add(msg, 'success')
  const error = (msg: string) => add(msg, 'error', 6_000)
  const warning = (msg: string) => add(msg, 'warning')
  const info = (msg: string) => add(msg, 'info')

  return { toasts, add, remove, success, error, warning, info }
})
